module.exports = __webpack_public_path__ + "static/img/marker-icon-grey-full.d6f1a53e.png";